module.exports = __webpack_public_path__ + "static/media/here-deck2.6a230623.png";